import { render, staticRenderFns } from "./rowitem.vue?vue&type=template&id=b3918fda&scoped=true"
import script from "./rowitem.vue?vue&type=script&lang=js"
export * from "./rowitem.vue?vue&type=script&lang=js"
import style0 from "./rowitem.vue?vue&type=style&index=0&id=b3918fda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3918fda",
  null
  
)

export default component.exports